import { DocumentSignKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetDocumentSignDocsPdfPageRequest, GetDocumentSignDocsPdfPageResponse } from "@maven-rest/docs/DocumentSign.dto";
import { DocumentSignUrl } from "@maven-rest/docs/DocumentSign.url";

export function useDocumentSignDocsPdfPageQuery(
  req: GetDocumentSignDocsPdfPageRequest,
  options?: SimpleQueryOptions<GetDocumentSignDocsPdfPageResponse, GetDocumentSignDocsPdfPageRequest>
) {
  return useBaseQuery({
    queryKey: [DocumentSignKey.DocumentSignDocsPdfPage, String(req.documentSignId), String(req.docsPdfId), req.page],
    fnOption: { url: DocumentSignUrl.getDocumentSignDocsPdfPage(req.documentSignId), request: req },
    ...options,
  });
}
